import { angleOfTwoLinesFromThreePoints, pointEquals } from "../../../geometry/operation";
import { Transform } from "../../../geometry/transformation";
import { RootState } from "../../../store/store";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { endRubberline } from "../../../store/interaction";
import { modelReplaceMultipleShapes } from "../../../store/model";
import BaseLine from "../shapes/line/LineBase";
import RenderSelection from "../util/RenderSelection";
import { registerToolRendererGroup } from "../util/shapeCategorySingleton"
import { transformShape } from "../util/shapeEdit";
import { strokeCorrection } from "../util/strokeCorrection";
import { useSnapMousePosition } from "./useSnapMousePosition";

const MirrorSymbol = () => {
  const dispatch = useAppDispatch();
  const selectionIds = useAppSelector((state: RootState) => state.model.present.selected.selectedItemIds)
  const shapes = useAppSelector((state: RootState) => state.model.present.model.shapes);
  const interaction = useAppSelector((state: RootState) => state.interaction)
  const scale = useAppSelector((state: RootState) => state.interface.viewport.scale)
  const mousePosition = useAppSelector((state: RootState) => state.interface.mousePosition);
  const defaultLineSetting = useAppSelector((state: RootState) => state.tool.toolSettings.move.symbolLine);
  const selectedShapes = shapes.filter((shape: GeometricShape) => selectionIds.find((selectionId) => shape.id === selectionId) !== undefined);
  const mousePositionSnap = useSnapMousePosition();


  // Modify Line properties for use of rotation symbol
  const internalLineProperties = {
    ...defaultLineSetting,
    id: -1,
    strokeWidth: strokeCorrection(defaultLineSetting.strokeWidth, scale),
    points: interaction.rubberlineData.snapPoints.concat(mousePositionSnap),
    draggable: false,
    closed: false,
  }

  // Points coming from clicks on the stage
  const pointBuffer = interaction.rubberlineData.snapPoints;

  const angle = (pointBuffer[0] && mousePosition && !pointEquals(pointBuffer[0], mousePosition)) ?
    angleOfTwoLinesFromThreePoints(pointBuffer[0], { x: pointBuffer[0].x, y: pointBuffer[0].y + 1, }, mousePositionSnap) :
    0;


  const mirrorTransformation = (pointBuffer[0] && !pointEquals(pointBuffer[0], mousePosition)) ?
    Transform.translationTransform(-pointBuffer[0].x, -pointBuffer[0].y)
      .rotate(-angle)
      .scale(-1, 1, 1)
      .rotate(angle)
      .translate(pointBuffer[0].x, pointBuffer[0].y) :
    new Transform();

  switch (pointBuffer.length) {
    case 0:
      break;
    case 1: {
      return (
        <>
          <BaseLine
            shapeProps={{
              ...internalLineProperties,
              points: [pointBuffer[0], mousePositionSnap]
            }} />

          <RenderSelection
            selectedItems={selectedShapes.map((s) => { return { ...s, mirrored: !s.mirrored } })}
            transform={mirrorTransformation}
          />

        </>
      );
    }
    case 2: {


      if (selectedShapes) {

        const newShapeList = selectedShapes.map((shape) => { return{ ...transformShape(shape, mirrorTransformation), mirrored: !shape.mirrored } })
        
        dispatch(modelReplaceMultipleShapes(newShapeList))

        dispatch(endRubberline());
      }

      break;
    }
    default: dispatch(endRubberline())
  }
  return (
    <></>
  )
}
const createMirrorSymbol = () => {
  return <MirrorSymbol />
}
registerToolRendererGroup("mirror", { toolRender: createMirrorSymbol })